import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { yonetim } from '../api';
import { ONAY_DURUMU, tarihSaat } from '../yardimcilar';
import DurumEtiketi from '../components/DurumEtiketi';
import Gorsel from '../components/Gorsel';
import OnayModal from '../components/OnayModal';

const SEKMELER = [
  { durum: ONAY_DURUMU.BEKLIYOR, ad: 'Bekleyen' },
  { durum: ONAY_DURUMU.ONAYLANDI, ad: 'Onaylı' },
  { durum: ONAY_DURUMU.REDDEDILDI, ad: 'Reddedilen' },
];

export default function Kuyumcular({ onDegisim }) {
  const [sekme, setSekme] = useState(ONAY_DURUMU.BEKLIYOR);
  const [kayitlar, setKayitlar] = useState([]);
  const [imlec, setImlec] = useState(null);
  const [yukleniyor, setYukleniyor] = useState(true);
  const [hata, setHata] = useState('');
  const [dahaVar, setDahaVar] = useState(false);
  const [kararKuyumcu, setKararKuyumcu] = useState(null);
  const navigate = useNavigate();

  const yukle = useCallback(async (durum, mevcutImlec) => {
    setHata('');
    setYukleniyor(true);
    try {
      const d = await yonetim.kuyumcular(durum, mevcutImlec);
      setKayitlar((onceki) => (mevcutImlec ? [...onceki, ...d.kayitlar] : d.kayitlar));
      setImlec(d.sonrakiImlec);
      setDahaVar(!!d.sonrakiImlec);
    } catch (e) {
      setHata(e.message);
    } finally {
      setYukleniyor(false);
    }
  }, []);

  useEffect(() => {
    setKayitlar([]);
    setImlec(null);
    yukle(sekme, null);
  }, [sekme, yukle]);

  async function kararVer(onayla, redNedeni) {
    await yonetim.kuyumcuKarar(kararKuyumcu.id, onayla, redNedeni);
    setKararKuyumcu(null);
    setKayitlar([]);
    yukle(sekme, null);
    onDegisim && onDegisim();
  }

  return (
    <div>
      <div className="page-header">
        <h1>Kuyumcu Onayları</h1>
        <p>Kuyumcu başvurularını görüntüleyin, düzenleyin, onaylayın veya reddedin</p>
      </div>

      <div className="tabs">
        {SEKMELER.map((s) => (
          <button key={s.durum} className={`tab${sekme === s.durum ? ' active' : ''}`} onClick={() => setSekme(s.durum)}>
            {s.ad}
          </button>
        ))}
      </div>

      {hata && <div className="mesaj hata">{hata}</div>}

      <div className="card tablo-kart">
        <table>
          <thead>
            <tr>
              <th>Logo</th>
              <th>İşletme</th>
              <th>Yetkili</th>
              <th>Telefon</th>
              <th>İl / İlçe</th>
              <th>Başvuru</th>
              <th>Durum</th>
              <th style={{ textAlign: 'right' }}>İşlem</th>
            </tr>
          </thead>
          <tbody>
            {kayitlar.map((k) => (
              <tr key={k.id}>
                <td><Gorsel url={k.logoUrl} className="logo-kucuk" alt={k.isletmeAdi} /></td>
                <td>
                  <strong>{k.isletmeAdi}</strong>
                  <div style={{ color: '#888', fontSize: 12 }}>{k.isyeriUnvani}</div>
                </td>
                <td>{k.yetkiliAdSoyad}</td>
                <td>{k.telefon}</td>
                <td>{k.ilAdi}{k.ilceAdi ? ` / ${k.ilceAdi}` : ''}</td>
                <td>{tarihSaat(k.olusturmaUtc)}</td>
                <td><DurumEtiketi durum={k.onayDurumu} ad={k.onayDurumuAdi} /></td>
                <td style={{ textAlign: 'right', whiteSpace: 'nowrap' }}>
                  <button className="btn btn-blue btn-sm" onClick={() => navigate(`/kuyumcular/${k.id}`)}>Detay</button>
                  {Number(k.onayDurumu) === ONAY_DURUMU.BEKLIYOR && (
                    <button className="btn btn-primary btn-sm" style={{ marginLeft: 6 }} onClick={() => setKararKuyumcu(k)}>
                      Karar ver
                    </button>
                  )}
                </td>
              </tr>
            ))}
            {!yukleniyor && kayitlar.length === 0 && (
              <tr><td colSpan={8} className="bos">Bu durumda kuyumcu bulunmuyor.</td></tr>
            )}
            {yukleniyor && kayitlar.length === 0 && (
              <tr><td colSpan={8} className="yukleniyor">Yükleniyor…</td></tr>
            )}
          </tbody>
        </table>
      </div>

      {dahaVar && (
        <div style={{ textAlign: 'center' }}>
          <button className="btn btn-gray" disabled={yukleniyor} onClick={() => yukle(sekme, imlec)}>
            {yukleniyor ? 'Yükleniyor…' : 'Daha fazla yükle'}
          </button>
        </div>
      )}

      {kararKuyumcu && (
        <OnayModal
          baslik={`Kuyumcu kararı — ${kararKuyumcu.isletmeAdi}`}
          aciklama="Onaylarsanız kuyumcu tam yetkiyle açılır ve bildirim alır. Reddederseniz gerekçe girmelisiniz."
          onKarar={kararVer}
          onKapat={() => setKararKuyumcu(null)}
        />
      )}
    </div>
  );
}
